import { render, staticRenderFns } from "./ecosystemList.vue?vue&type=template&id=2dbe7604&scoped=true&"
import script from "./ecosystemList.vue?vue&type=script&lang=js&"
export * from "./ecosystemList.vue?vue&type=script&lang=js&"
import style0 from "./ecosystemList.vue?vue&type=style&index=0&id=2dbe7604&prod&lang=css&"
import style1 from "./ecosystemList.vue?vue&type=style&index=1&id=2dbe7604&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe7604",
  null
  
)

export default component.exports